export const Instrumento = [
  {
    id_instrumento: 202,
    nombre_instrumento: "Test 1",
    total_preguntas: 32,
    preguntas: [
      {
        id_pregunta: 20201,
        id_instrumento: 202,
        id_correlativo: 1,
        texto: "Me ocurren más cosas buenas que malas",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20202,
        id_instrumento: 202,
        id_correlativo: 2,
        texto: "Me ocurren más cosas malas que buenas",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20203,
        id_instrumento: 202,
        id_correlativo: 3,
        texto: "Ante cualquier experiencia, miro el lado positivo",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20204,
        id_instrumento: 202,
        id_correlativo: 4,
        texto: "Ante cualquier experiencia, observo que cosa negativa tendrá",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20205,
        id_instrumento: 202,
        id_correlativo: 5,
        texto:
          "Sé que me fue mal en esa prueba porque no la preparé, no estudie como debía",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20206,
        id_instrumento: 202,
        id_correlativo: 6,
        texto: "Me fue mal en ese examen porque soy muy nervioso/a",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20207,
        id_instrumento: 202,
        id_correlativo: 7,
        texto: "En tiempos difíciles, suelo esperar lo mejor",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20208,
        id_instrumento: 202,
        id_correlativo: 8,
        texto: "A veces pienso que tengo mala suerte",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20209,
        id_instrumento: 202,
        id_correlativo: 9,
        texto: "Tengo fe de que todas mis cosas van a mejorar",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20210,
        id_instrumento: 202,
        id_correlativo: 10,
        texto:
          "Tengo dudas respecto a si realmente mis problemas van a mejorar",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20211,
        id_instrumento: 202,
        id_correlativo: 11,
        texto: "Espero alcanzar mis metas",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20212,
        id_instrumento: 202,
        id_correlativo: 12,
        texto: "No sé si lograré alcanzar mis metas",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20213,
        id_instrumento: 202,
        id_correlativo: 13,
        texto: "Tengo muchos proyectos en mente",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20214,
        id_instrumento: 202,
        id_correlativo: 14,
        texto: "No identifico proyectos que quiera realizar",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20215,
        id_instrumento: 202,
        id_correlativo: 15,
        texto: "Tengo cosas muy importantes que hacer en mi vida",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20216,
        id_instrumento: 202,
        id_correlativo: 16,
        texto:
          "Vivo el día a día, sin pensar en las cosas que tengo que hacer en mi vida",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20217,
        id_instrumento: 202,
        id_correlativo: 17,
        texto: "Si me esfuerzo, puedo resolver problemas complejos",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20218,
        id_instrumento: 202,
        id_correlativo: 18,
        texto:
          "Creo que tengo menos habilidades que otros para resolver problemas difíciles",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20219,
        id_instrumento: 202,
        id_correlativo: 19,
        texto: "Se que puedo manejar situaciones imprevistas o inesperadas",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20220,
        id_instrumento: 202,
        id_correlativo: 20,
        texto: "Me cuesta manejar situaciones repentinas o inesperadas",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20221,
        id_instrumento: 202,
        id_correlativo: 21,
        texto: "Tengo capacidades desarrolladas para manejar nuevos desafíos",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20222,
        id_instrumento: 202,
        id_correlativo: 22,
        texto:
          "Frente a nuevos desafíos, no sé si tengo las capacidades para enfrentarlos",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20223,
        id_instrumento: 202,
        id_correlativo: 23,
        texto: "Puedo conseguir lo que me propongo, aunque el resto se oponga",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20224,
        id_instrumento: 202,
        id_correlativo: 24,
        texto: "Me cuesta conseguir lo que quiero si el resto se opone",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20225,
        id_instrumento: 202,
        id_correlativo: 25,
        texto:
          "Soy capaz de superar momentos difíciles porque ya he pasado por dificultades",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20226,
        id_instrumento: 202,
        id_correlativo: 26,
        texto:
          "Me cuesta recuperarme frente a situaciones difíciles de mi vida",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20227,
        id_instrumento: 202,
        id_correlativo: 27,
        texto: "Soy capaz de volverme a parar",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20228,
        id_instrumento: 202,
        id_correlativo: 28,
        texto: "Cuando algo no me funciona me decaigo",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20229,
        id_instrumento: 202,
        id_correlativo: 29,
        texto: "Cuando tengo una dificultad, se cómo resolverla",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20230,
        id_instrumento: 202,
        id_correlativo: 30,
        texto: "Cuando tengo una dificultad, me aflijo, me amargo",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20231,
        id_instrumento: 202,
        id_correlativo: 31,
        texto: "Me siento con energía para hacer lo que tengo que hacer",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
      {
        id_pregunta: 20232,
        id_instrumento: 202,
        id_correlativo: 32,
        texto: "A veces me faltan fuerzas para hacer lo que tengo que hacer",
        alt1: "Completamente de acuerdo",
        alt2: "De acuerdo",
        alt3: "Algo de acuerdo",
        alt4: "Algo en desacuerdo",
        alt5: "En desacuerdo",
        alt6: "Completamente en desacuerdo",
      },
    ],
  },
  {
    id_instrumento: 203,
    nombre_instrumento: "Test 3",
    total_preguntas: 5,
    preguntas: [
      {
        id_pregunta: 20301,
        id_instrumento: 203,
        id_correlativo: 1,
        texto:
          "Juan es un joven de 25 años, nacido en una región del sur, interesado por las matemáticas. Cuando era estudiante estaba muy preocupado por temas de medio ambiente y cambio climático.",
        alt1: "Juan es ahora profesor de matemáticas",
        alt2: "Juan es ahora profesor de matemáticas y un activista ambientalista",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20302,
        id_instrumento: 203,
        id_correlativo: 2,
        texto:
          "Tu jefe inicia un debate con otra persona de la organización. Usted piensa: ",
        alt1: "Mi jefe tiene más razón que la otra persona",
        alt2: "No sé quién tiene más razón",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20303,
        id_instrumento: 203,
        id_correlativo: 3,
        texto:
          "¿ Usted considera que viajar en avión es más peligroso que viajar en auto ?",
        alt1: "Si",
        alt2: "No",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20304,
        id_instrumento: 203,
        id_correlativo: 4,
        texto:
          "Usted quiere saber si las zapatillas 'A' son mejores que las 'B'.",
        alt1: "¿ Son las zapatillas 'A' mejores que las 'B' ? ",
        alt2: "¿ Son las zapatillas 'B' mejores que las 'A' ? ",
        alt3: "¿ Cuál zapatilla es mejor, A o B ? ",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20305,
        id_instrumento: 203,
        id_correlativo: 5,
        texto:
          "Estime el porcentaje de la población de su misma edad, educación y sexo que es mejor que usted en las siguientes características. Por ejemplo, si usted considera que sólo el 10% de las personas de su edad, educación y sexo conducen mejor que usted, marque 10%",
        alt1: "",
        alt2: "",
        alt3: "",
        alt4: "",
        alt5: "",
      },
    ],
  },
  {
    id_instrumento: 204,
    nombre_instrumento: "Test 4",
    total_preguntas: 53,
    preguntas: [
      {
        id_pregunta: 20401,
        id_instrumento: 204,
        id_correlativo: 1,
        texto:
          "Los cambios en las compañías no me generan expectativas de crecimiento personal",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20402,
        id_instrumento: 204,
        id_correlativo: 2,
        texto:
          "Los cambios en las compañías no me generan entusiasmo de un futuro mejor",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20403,
        id_instrumento: 204,
        id_correlativo: 3,
        texto:
          "A veces siento que es mejor fingir que se está haciendo el trabajo de forma distinta y así evitar problemas",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20404,
        id_instrumento: 204,
        id_correlativo: 4,
        texto:
          "Creo que en ocasiones los cambios solo ocurren a nivel de discurso",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20405,
        id_instrumento: 204,
        id_correlativo: 5,
        texto: "Considero que, muchas veces, los cambios están mal planeados",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20406,
        id_instrumento: 204,
        id_correlativo: 6,
        texto:
          "Creo que, muchas veces, los objetivos de un proyecto no se concretarán",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20407,
        id_instrumento: 204,
        id_correlativo: 7,
        texto:
          "He aprendido a decir que si, aunque piense que no, en favor de la organización ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20408,
        id_instrumento: 204,
        id_correlativo: 8,
        texto:
          "Me he pillado intercambiando miradas de complicidad con mis colegas cuando anuncian un cambio",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20409,
        id_instrumento: 204,
        id_correlativo: 9,
        texto:
          "En las empresas, suelen pedir una cosa, pero, se recompensa otra",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20410,
        id_instrumento: 204,
        id_correlativo: 10,
        texto:
          "Dudo de los cambios que las empresas dicen que son a favor de los empleados",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20411,
        id_instrumento: 204,
        id_correlativo: 11,
        texto:
          "A los operadores/as se los ignora al momento de participar en la toma de decisiones",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20412,
        id_instrumento: 204,
        id_correlativo: 12,
        texto:
          "Hay ocasiones en que he considerado que los jefes/as son egoístas",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20413,
        id_instrumento: 204,
        id_correlativo: 13,
        texto:
          "Me gusta operar de memoria, cuando uno ya domina el quehacer no hay que perder tiempo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20414,
        id_instrumento: 204,
        id_correlativo: 14,
        texto: "Si no sé, no opino, prefiero decir que no sé ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20415,
        id_instrumento: 204,
        id_correlativo: 15,
        texto:
          "Estudio sobre lo que no domino, porque sobre lo que ya domino es innecesario",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20416,
        id_instrumento: 204,
        id_correlativo: 16,
        texto: "Levantar peligros o amenazas enlentece la ejecución",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20417,
        id_instrumento: 204,
        id_correlativo: 17,
        texto:
          "Las dudas se resuelven antes de operar, operando no se hacen consultas",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20418,
        id_instrumento: 204,
        id_correlativo: 18,
        texto: "Es importante para mí, no dar por sentado lo que ignoro",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20419,
        id_instrumento: 204,
        id_correlativo: 19,
        texto:
          "Toda situación tiene pros y contra, por lo que sospecho de mí mismo si sólo veo pros",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20420,
        id_instrumento: 204,
        id_correlativo: 20,
        texto:
          "Cuando alguien me plantea algo que sólo tiene ventajas, desconfío",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20421,
        id_instrumento: 204,
        id_correlativo: 21,
        texto:
          "Está bien ser cauteloso, pero no al punto de que te enlentezca ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20422,
        id_instrumento: 204,
        id_correlativo: 22,
        texto:
          "Estudio sobre sesgos constantemente, para que mi mirada sea más objetiva",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20423,
        id_instrumento: 204,
        id_correlativo: 23,
        texto:
          "La “pillería del chileno” para mi es un valor, uno se las rebusca y resuelve",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20424,
        id_instrumento: 204,
        id_correlativo: 24,
        texto:
          "Si se me cruza un gato negro sé que será mal augurio, entonces ando con más cuidado",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20425,
        id_instrumento: 204,
        id_correlativo: 25,
        texto:
          "Si durante el almuerzo se me cae la sal yo sé que pasará algo, entonces ando con más cuidado",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20426,
        id_instrumento: 204,
        id_correlativo: 26,
        texto:
          "Si me estoy por demorar 13 minutos en terminar algo, me apuro o me atraso, pero prefiero no demorarme 13 minutos",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20427,
        id_instrumento: 204,
        id_correlativo: 27,
        texto: "Si se me llega a quebrar un espejo, ando con más cuidado",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20428,
        id_instrumento: 204,
        id_correlativo: 28,
        texto:
          "Tengo una prenda de la suerte, que no falla, la uso siempre que la necesito",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20429,
        id_instrumento: 204,
        id_correlativo: 29,
        texto:
          "Tengo una cábala o ritual que hago siempre antes de empezar algo riesgoso",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20430,
        id_instrumento: 204,
        id_correlativo: 30,
        texto:
          "No me preguntes por qué, pero siempre que pasan 2 accidentes juntos, viene un 3ero",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20431,
        id_instrumento: 204,
        id_correlativo: 31,
        texto:
          "Por si acaso, rezo antes de empezar, porque así me siento más seguro",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20432,
        id_instrumento: 204,
        id_correlativo: 32,
        texto:
          "Tengo una frase que uso para minimizar los riesgos, porque me resulta",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20433,
        id_instrumento: 204,
        id_correlativo: 33,
        texto: "En minería tenemos cábalas o rituales y hay que respetarlas/os",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      /////=============================================================
      {
        id_pregunta: 20434,
        id_instrumento: 204,
        id_correlativo: 34,
        texto: "Me gusta “estar a la moda”",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20435,
        id_instrumento: 204,
        id_correlativo: 35,
        texto:
          "Tengo amigos/as osados/as, valientes y me gustaría ser como ellos/as",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20436,
        id_instrumento: 204,
        id_correlativo: 36,
        texto:
          "A veces pienso distinto al grupo, pero lo mejor para no tener problemas, es seguir a la mayoría",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20437,
        id_instrumento: 204,
        id_correlativo: 37,
        texto:
          "He afirmado cosas con las cuales no estoy muy de acuerdo por compañerismo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20438,
        id_instrumento: 204,
        id_correlativo: 38,
        texto: "Tengo varios influencer a quienes sigo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20439,
        id_instrumento: 204,
        id_correlativo: 39,
        texto:
          "Reconozco haberme subido a una montaña rusa por la insistencia de otros/as",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20440,
        id_instrumento: 204,
        id_correlativo: 40,
        texto:
          "Me he unido a participar en un desafío viral en las redes sociales, al igual que mis amigos/as",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20441,
        id_instrumento: 204,
        id_correlativo: 41,
        texto:
          "Reconozco que, frente a una opinión importante para mí, a veces la he cambiado, por la insistencia del grupo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20442,
        id_instrumento: 204,
        id_correlativo: 42,
        texto: "Me cuesta decir que no cuando me piden seguir una cadena",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20443,
        id_instrumento: 204,
        id_correlativo: 43,
        texto: "A veces he cometido errores por seguir a otros/as",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20444,
        id_instrumento: 204,
        id_correlativo: 44,
        texto:
          "Me considero una persona difícil de dejarse influenciar por otros",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20445,
        id_instrumento: 204,
        id_correlativo: 45,
        texto:
          "He firmado, o aprobado una petición porque un amigo/a me lo pidió, aunque no estaba comprometido/a con la causa.",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20446,
        id_instrumento: 204,
        id_correlativo: 46,
        texto: "Hay cosas que hago para ser aceptada/o por otras/os",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20447,
        id_instrumento: 204,
        id_correlativo: 47,
        texto: "Me corto el pelo, o me peino, como mi ídolo/a",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20448,
        id_instrumento: 204,
        id_correlativo: 48,
        texto: "He hecho muchas cosas guiándome por personas a quienes admiro",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20449,
        id_instrumento: 204,
        id_correlativo: 49,
        texto: "En ocasiones, mis creencias, me han impedido actuar",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20450,
        id_instrumento: 204,
        id_correlativo: 50,
        texto:
          "A veces no me siento libre de dar una opinión por la presión del grupo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20451,
        id_instrumento: 204,
        id_correlativo: 51,
        texto: "He participado en deportes extremos siguiendo a mi grupo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20452,
        id_instrumento: 204,
        id_correlativo: 52,
        texto:
          "En mi trabajo he seguido a personas que me han influenciado positivamente",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20453,
        id_instrumento: 204,
        id_correlativo: 53,
        texto:
          "Mis amigos/as, en ocasiones, me han impulsado a arriesgarme más de la cuenta",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
    ],
  },
  {
    id_instrumento: 205,
    nombre_instrumento: "Test 5",
    total_preguntas: 44,
    preguntas: [
      {
        id_pregunta: 20501,
        id_instrumento: 205,
        id_correlativo: 1,
        texto: "Me conozco y sé como reacciono ante ciertas provocaciones",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20502,
        id_instrumento: 205,
        id_correlativo: 2,
        texto: "Hay cosas que me sacan de quicio y me nublo, pero son pocas",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20503,
        id_instrumento: 205,
        id_correlativo: 3,
        texto: "Me cuesta contar que me está pasando algo que me afecta",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20504,
        id_instrumento: 205,
        id_correlativo: 4,
        texto: "Si tengo un problema suelo afrontarlo solo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20505,
        id_instrumento: 205,
        id_correlativo: 5,
        texto:
          "Me doy cuenta cuando algo me está afectando y controlo mi respiración",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20506,
        id_instrumento: 205,
        id_correlativo: 6,
        texto: "Sé exacto donde aprieto mi cuerpo cuando me estoy enojando",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20507,
        id_instrumento: 205,
        id_correlativo: 7,
        texto: "Sufro crisis de pánico y no se las doy a nadie ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20508,
        id_instrumento: 205,
        id_correlativo: 8,
        texto:
          "A veces me siento eufórico por algo y pienso “sooo, cálmate, respira”",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20509,
        id_instrumento: 205,
        id_correlativo: 9,
        texto: "Tengo una técnica para relajarme cuando estoy nervioso",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20510,
        id_instrumento: 205,
        id_correlativo: 10,
        texto:
          "Sé que en la confianza está el peligro, pero tampoco es para tanto",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20511,
        id_instrumento: 205,
        id_correlativo: 11,
        texto:
          "Mi vida es valiosa, pero menos que la de otros que tienen personas que dependen de ellos",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20512,
        id_instrumento: 205,
        id_correlativo: 12,
        texto:
          "Carpe diem “vive el momento” es parte de mi filosofía, porque uno no sabe si habrá mañana",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20513,
        id_instrumento: 205,
        id_correlativo: 13,
        texto:
          "Podré pasarme un poco de 120, pero manejar a más de 140 me da miedo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20514,
        id_instrumento: 205,
        id_correlativo: 14,
        texto: "Tengo un propósito que cumplir en esta vida",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20515,
        id_instrumento: 205,
        id_correlativo: 15,
        texto: "Cuido mi vida, porque es muy valiosa",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20516,
        id_instrumento: 205,
        id_correlativo: 16,
        texto: "Me preocupa que me pase algo porque mucha gente depende de mi",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20517,
        id_instrumento: 205,
        id_correlativo: 17,
        texto: "Siento la responsabilidad de que afecto a otros ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20518,
        id_instrumento: 205,
        id_correlativo: 18,
        texto: "Mis actos me definen, por eso cuido mi conducta",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20519,
        id_instrumento: 205,
        id_correlativo: 19,
        texto: "Eres lo que haces, porque las palabras se las lleva el viento",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20520,
        id_instrumento: 205,
        id_correlativo: 20,
        texto: "Me cargan los que predican, pero no practican",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20521,
        id_instrumento: 205,
        id_correlativo: 21,
        texto:
          "Se que puedo resolver cualquier problema, porque he enfrentado en mi vida situaciones difíciles y he salido de ellas gracias a mis capacidades",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20522,
        id_instrumento: 205,
        id_correlativo: 22,
        texto:
          "Si algo se me cae o cometo alguna torpeza, reviso cómo me siento para tener claridad de si fue un hecho aislado o si es una alerta (de cansancio o estrés)",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20523,
        id_instrumento: 205,
        id_correlativo: 23,
        texto:
          "Se que cometer errores en el trabajo puede costar la vida, entonces si no me siento 100% óptimo para trabajar, aviso ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20524,
        id_instrumento: 205,
        id_correlativo: 24,
        texto:
          "Sé que los accidentes ocurren principalmente por sobreconfianza, por lo que si me siento seguro invierto más en cumplir los procedimientos",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20525,
        id_instrumento: 205,
        id_correlativo: 25,
        texto:
          "Hay acciones que uno se puede saltar cuando ya tienes experiencia, esa es la gracia de tener oficio ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20526,
        id_instrumento: 205,
        id_correlativo: 26,
        texto:
          "Si algo me tiene desconcentrado le aviso a mi equipo o jefe para que me apoyen",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20527,
        id_instrumento: 205,
        id_correlativo: 27,
        texto:
          "Si estoy durmiendo mal, sé exacto qué hacer para no generar riesgos en el trabajo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20528,
        id_instrumento: 205,
        id_correlativo: 28,
        texto:
          "Sé que cosas me afectan más en mi estado basal, entonces cuido esos factores ocupándome de dormir bien, hidratarme bien, comer bien, no sobrepensar, etc. ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20529,
        id_instrumento: 205,
        id_correlativo: 29,
        texto:
          "Si observo que alguien en mi equipo está actuando con sobreconfianza no me quedo callado, porque sé que está poniendo a la compañía en riesgo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20530,
        id_instrumento: 205,
        id_correlativo: 30,
        texto: "En el ámbito laboral la “chispeza” es un riesgo ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20531,
        id_instrumento: 205,
        id_correlativo: 31,
        texto:
          "Me cuido en términos de salud, porque estar saludable es parte de hacer bien la pega ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20532,
        id_instrumento: 205,
        id_correlativo: 32,
        texto: "Ante escenarios de crisis emerge mi mejor versión ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20533,
        id_instrumento: 205,
        id_correlativo: 33,
        texto: "Ante situaciones críticas yo he tomado la batuta ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20534,
        id_instrumento: 205,
        id_correlativo: 34,
        texto:
          "Busco relacionarme con personas que cuestionen mis perspectivas",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20535,
        id_instrumento: 205,
        id_correlativo: 35,
        texto: "Cuando todos opinan lo mismo, se me despierta un alerta ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20536,
        id_instrumento: 205,
        id_correlativo: 36,
        texto:
          "Me intereso e indago cuando veo pasiones de otros, que son completamente ajenas a las mías",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20537,
        id_instrumento: 205,
        id_correlativo: 37,
        texto: "Me suelo cuestionar a mí mismo ",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20538,
        id_instrumento: 205,
        id_correlativo: 38,
        texto: "Disfruto de abrir el debate",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20539,
        id_instrumento: 205,
        id_correlativo: 39,
        texto: "Busco entender cómo otros podrían ver el problema",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20540,
        id_instrumento: 205,
        id_correlativo: 40,
        texto:
          "Suelo preguntarme: cómo resolvería esto si tuviera recursos ilimitados o cero peso",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20541,
        id_instrumento: 205,
        id_correlativo: 41,
        texto:
          "Prefiero concentrarme en hacer lo que tengo que hacer, más que estar imaginando otras formas",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20542,
        id_instrumento: 205,
        id_correlativo: 42,
        texto: "Permanentemente trato de desafiar mis creencias o prejuicios",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20543,
        id_instrumento: 205,
        id_correlativo: 43,
        texto:
          "Si encuentro evidencias a favor de algo, suelo buscar si existen evidencias en contra",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20544,
        id_instrumento: 205,
        id_correlativo: 44,
        texto:
          "No entiendo para qué tanto cuestionar cómo hacemos las cosas, mejor dedicarse a hacerlas bien",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
    ],
  },
  {
    id_instrumento: 206,
    nombre_instrumento: "Test 6",
    total_preguntas: 10,
    preguntas: [
      {
        id_pregunta: 20601,
        id_instrumento: 206,
        id_correlativo: 1,
        texto:
          "Qué harías si te encuentras con una realidad distinta de la planificada para tu jornada",
        alt1: "Paro y pido instrucciones",
        alt2: "Evalúo cuán crítica es, para ver si paro o sigo",
        alt3: "Resuelvo, tendré que ver cómo sigo, pero a menos que se derrumbe el mundo yo no paro, la continuidad operacional es lo más importante",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20602,
        id_instrumento: 206,
        id_correlativo: 2,
        texto: "Cómo calificarías el choque del Ferrari de Arturo Vidal",
        alt1: "A cualquiera le puede pasar",
        alt2: "No creo que haya sido para tanto, sólo que él es famoso",
        alt3: "Imprudente por donde se lo mire",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20603,
        id_instrumento: 206,
        id_correlativo: 3,
        texto:
          "Estás un poco atrasado/a en tu ruta, porque hubo contratiempos y te surgen muchas ganas de orinar",
        alt1: "Termino primero la ruta, de alguna manera aguanto",
        alt2: "Paro y voy al baño, es demasiado importante manejar tranquilo",
        alt3: "Busco una solución intermedia, seguro tengo algo disponible para resolver",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20604,
        id_instrumento: 206,
        id_correlativo: 4,
        texto:
          "Eres chofer de micro y una persona empieza a convulsionar en la mitad de tu ruta",
        alt1: "Aviso a mi jefatura y sigo instrucciones",
        alt2: "Me desvío al recinto asistencial más cercano",
        alt3: "Sigo en la ruta, porque los demás pasajeros también merecen respeto",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20605,
        id_instrumento: 206,
        id_correlativo: 5,
        texto: "Vas atrasado en tu ruta, porque hubo imprevistos en el camino",
        alt1: "Tratas de apurarte un poco y recuperar algo del tiempo perdido, sin exagerar",
        alt2: "Aceleras y te hiper concentras para estar atento a que todo salga bien",
        alt3: "Notificas por radio que vas atrasado",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20606,
        id_instrumento: 206,
        id_correlativo: 6,
        texto:
          "Te vas a ir de vacaciones a Brasil en pleno verano y estás armando tu maleta",
        alt1: "Reviso qué clima va a haber antes de hacer la maleta, podrá ser obvio, porque es verano, pero igual lo reviso por si acaso",
        alt2: "Llevo un short y una polera, no necesito nada más",
        alt3: "No reviso el clima, armo algo variado con prendas para todo tipo de clima",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20607,
        id_instrumento: 206,
        id_correlativo: 7,
        texto:
          "Vas manejando y de pronto todo se ve negro, no ves nada sólo hay oscuridad",
        alt1: "Sigues avanzando porque la ruta está demarcada y el gps te muestra claramente el camino",
        alt2: "Frenas, señalizas e intentas comunicarte con tu superior para tener información",
        alt3: "Buscas si tienes algo con qué alumbrar, mientras mantienes tu ruta",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20608,
        id_instrumento: 206,
        id_correlativo: 8,
        texto:
          "Tienes la camioneta más grande del mercado (F150 o Silverado) vas manejando por la calle en la ciudad y de pronto te interceptan para asaltarte con pistolas",
        alt1: "Veo si tengo espacio para arrancar, trato de arrancar",
        alt2: "Me bajo y entrego todo",
        alt3: "Simulo desmayarme dentro del auto, total siempre ando con los pestillos puestos, no van a poder abrir",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20609,
        id_instrumento: 206,
        id_correlativo: 9,
        texto:
          "Voy manejando por la carretera, estoy a 30 minutos de llegar a mi casa, siento que empiezo a pestañar pesado,  y estoy a dos minutos de pasar por una bomba de bencina",
        alt1: "No me falta nada, yo sé que aguanto 30 minutos más, así que no pierdo tiempo en parar, sigo",
        alt2: "Paro, me bajo, me mojo la cara y sigo",
        alt3: "Paro, descanso un rato y luego analizo si retomo",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20610,
        id_instrumento: 206,
        id_correlativo: 10,
        texto:
          "Te levantaste y cuando te fuiste a vestir no encontrabas calcetines, después te fuiste a tomar un café y se te dio vuelta, tuviste que cambiarte de ropa, partiste a trabajar, llegaste y te diste cuenta que se te quedaron los guantes de seguridad, pides unos prestados y sólo quedan unos que te quedan apretados",
        alt1: "Le avisas a tu jefe de turno que necesitas otros guantes, para ver si te puede ayudar",
        alt2: "Le dices a tu jefe que estás enfermo del estómago, que no puedes trabajar",
        alt3: "Le cuentas a tu jefe la mañana que has tenido y evalúan juntos si estás en condiciones de trabajar",
        alt4: "",
        alt5: "",
      },
    ],
  },
  {
    id_instrumento: 207,
    nombre_instrumento: "Test 7",
    total_preguntas: 21,
    preguntas: [
      {
        id_pregunta: 20701,
        id_instrumento: 207,
        id_correlativo: 1,
        texto: "A veces pienso distinto al grupo, pero la mayoría manda",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20702,
        id_instrumento: 207,
        id_correlativo: 1,
        texto: "Si lo hace mi influencer yo lo/a sigo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20703,
        id_instrumento: 207,
        id_correlativo: 3,
        texto: "Lo que dice mi comunidad es determinante para mí",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20704,
        id_instrumento: 207,
        id_correlativo: 4,
        texto: "Creo en lo que dicen mis redes sociales",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20705,
        id_instrumento: 207,
        id_correlativo: 5,
        texto:
          "Solo mi experiencia y la de mis cercanos, me permite identificar con claridad lo que es, o no es, riesgoso",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20706,
        id_instrumento: 207,
        id_correlativo: 6,
        texto: "Me gusta parecerme a los lideres de mi barrio",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20707,
        id_instrumento: 207,
        id_correlativo: 7,
        texto:
          "Hay medidas preventivas en las empresas que no consideran lo que el grupo de trabajadores sabe y por eso no las seguimos",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20708,
        id_instrumento: 207,
        id_correlativo: 8,
        texto:
          "En mi experiencia laboral he cometido errores por seguir al líder",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20709,
        id_instrumento: 207,
        id_correlativo: 9,
        texto:
          "Me considero una persona difícil de dejarse influenciar por otros",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20710,
        id_instrumento: 207,
        id_correlativo: 10,
        texto:
          "En mi barrio, hay personas que viven muy cerca del peligro a quienes admiro",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20711,
        id_instrumento: 207,
        id_correlativo: 11,
        texto:
          "TIK TOK ha pasado a ser una fuente de información muy valiosa para mí",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20712,
        id_instrumento: 207,
        id_correlativo: 12,
        texto:
          "Frente a situaciones de riesgo, la pertenencia a mi grupo me protege",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20713,
        id_instrumento: 207,
        id_correlativo: 13,
        texto:
          "A veces estoy dispuesto/a a correr ciertos riesgos con tal de destacarme",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20714,
        id_instrumento: 207,
        id_correlativo: 14,
        texto:
          "He realizado acciones riesgosas pero que me han generado el reconocimiento del grupo",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20715,
        id_instrumento: 207,
        id_correlativo: 15,
        texto:
          "Hay situaciones en que he dicho “si mis compañeros no usan un equipo de seguridad” ¿porque lo voy a usar yo?",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20716,
        id_instrumento: 207,
        id_correlativo: 16,
        texto:
          "Si subo a mi red una foto haciendo una acción peligrosa, tengo muchos deditos hacia arriba",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20717,
        id_instrumento: 207,
        id_correlativo: 17,
        texto: "Si subo a mi red una buena práctica, casi nadie me pesca",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20718,
        id_instrumento: 207,
        id_correlativo: 18,
        texto: "Sigo a unos cuantos influencers en mi actuación diaria",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20719,
        id_instrumento: 207,
        id_correlativo: 19,
        texto: "He hecho muchas cosas guiándome por mis propios ídolos",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20720,
        id_instrumento: 207,
        id_correlativo: 20,
        texto: "Mis compañeros me ayudan en mi toma de decisiones",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
      {
        id_pregunta: 20721,
        id_instrumento: 207,
        id_correlativo: 21,
        texto: "Reforzar conductas seguras está bien pero es de nerd",
        alt1: "Me describe completamente",
        alt2: "Me describe casi completamente",
        alt3: "Ni sí, ni no",
        alt4: "Casi no me describe",
        alt5: "No me describe para nada",
      },
    ],
  },
  {
    id_instrumento: 208,
    nombre_instrumento: "Test 2",
    total_preguntas: 40,
    preguntas: [
      {
        id_pregunta: 20801,
        id_instrumento: 208,
        id_correlativo: 1,
        texto: "",
        alt1: "Generalmente actúo con visión positiva",
        alt2: "Generalmente actúo con visión preventiva",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20802,
        id_instrumento: 208,
        id_correlativo: 2,
        texto: "",
        alt1: "Si me presentan un problema, lo evalúo",
        alt2: "Si me presentan un problema, lo enfrento",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20803,
        id_instrumento: 208,
        id_correlativo: 3,
        texto: "",
        alt1: "Generalmente actúo con determinación",
        alt2: "Generalmente actúo con precaución",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20804,
        id_instrumento: 208,
        id_correlativo: 4,
        texto: "",
        alt1: "Me esfuerzo para conseguir lo que me propongo",
        alt2: "Tengo fe de conseguir lo que me propongo",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20805,
        id_instrumento: 208,
        id_correlativo: 5,
        texto: "",
        alt1: "Procedo con seguridad en mí mismo/a ante cualquier hecho",
        alt2: "Procedo con cautela ante cualquier hecho",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20806,
        id_instrumento: 208,
        id_correlativo: 6,
        texto: "",
        alt1: "Mis capacidades me permiten actuar con rapidez",
        alt2: "Mis capacidades me permiten seguir el ritmo de los demás",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20807,
        id_instrumento: 208,
        id_correlativo: 7,
        texto: "",
        alt1: "Sé lo que tengo que hacer y lo hago",
        alt2: "Observo lo que tengo que hacer y lo hago",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20808,
        id_instrumento: 208,
        id_correlativo: 8,
        texto: "",
        alt1: "Actúo con tacto",
        alt2: "Actúo con audacia",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20809,
        id_instrumento: 208,
        id_correlativo: 9,
        texto: "",
        alt1: "Actúo con vigor y eficiencia",
        alt2: "Actúo con cuidado y tranquilidad",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20810,
        id_instrumento: 208,
        id_correlativo: 10,
        texto: "",
        alt1: "Actúo confiando en mi valía personal",
        alt2: "Actúo siguiendo al líder",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20811,
        id_instrumento: 208,
        id_correlativo: 11,
        texto: "",
        alt1: "Prefiero ser precavido",
        alt2: "Prefiero ser resuelto y actuar con agilidad",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20812,
        id_instrumento: 208,
        id_correlativo: 12,
        texto: "",
        alt1: "Actúo con mentalidad cuidadosa",
        alt2: "Actúo con mentalidad ganadora",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20813,
        id_instrumento: 208,
        id_correlativo: 13,
        texto: "",
        alt1: "Suelo ser cauto/a",
        alt2: "Suelo ser confiado/a",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20814,
        id_instrumento: 208,
        id_correlativo: 14,
        texto: "",
        alt1: "Creo firmemente que tengo buenas capacidades para realizar mi trabajo",
        alt2: "Conozco cuales son mis capacidades para realizar mi trabajo",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20815,
        id_instrumento: 208,
        id_correlativo: 15,
        texto: "",
        alt1: "Más bien soy tímido/a",
        alt2: "Más bien soy espontaneo/a",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20816,
        id_instrumento: 208,
        id_correlativo: 16,
        texto: "",
        alt1: "Tengo coraje",
        alt2: "Tengo prudencia",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20817,
        id_instrumento: 208,
        id_correlativo: 17,
        texto: "",
        alt1: "Suelo ser replegado/a",
        alt2: "Suelo ser osado/a",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20818,
        id_instrumento: 208,
        id_correlativo: 18,
        texto: "",
        alt1: "Me gusta hacer pruebas en lo que hago",
        alt2: "Me gusta seguir procedimientos en lo que hago",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20819,
        id_instrumento: 208,
        id_correlativo: 19,
        texto: "",
        alt1: "Comparado/a con mis compañeros/as soy más confiado/a en mí mismo/a que ellos/as",
        alt2: "Comparado/a con mis compañeros/as soy más disciplinado que ellos/as",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20820,
        id_instrumento: 208,
        id_correlativo: 20,
        texto: "",
        alt1: "Comparado/a con mis compañeros/as, me equivoco menos que ellos/as",
        alt2: "Comparado/a con mis compañeros/as, soy más cauteloso/a que ellos/as",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20821,
        id_instrumento: 208,
        id_correlativo: 21,
        texto: "",
        alt1: "Comparado/a con mis compañeros/as, soy más entusiasta que ellos/as",
        alt2: "Comparado/a con mis compañeros/as, soy más crítico/a que ellos/as",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20822,
        id_instrumento: 208,
        id_correlativo: 22,
        texto: "",
        alt1: "En mi trabajo me destaco por ser verificador/a ",
        alt2: "En mi trabajo me destaco por ser ejecutivo/a",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20823,
        id_instrumento: 208,
        id_correlativo: 23,
        texto: "",
        alt1: "En mi trabajo soy más alentador/a que el resto",
        alt2: "En mi trabajo soy más controlador/a que el resto",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20824,
        id_instrumento: 208,
        id_correlativo: 24,
        texto: "",
        alt1: "En mi trabajo soy más aplicado/a que el resto",
        alt2: "En mi trabajo soy más resolutivo/a que el resto",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20825,
        id_instrumento: 208,
        id_correlativo: 25,
        texto: "",
        alt1: "Me caracterizo por ser crítico/a de mí mismo ",
        alt2: "Me caracterizo por ser seguro/a de mí mismo/a",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20826,
        id_instrumento: 208,
        id_correlativo: 26,
        texto: "",
        alt1: "Ante tareas nuevas me valgo de mis propios recursos para resolverlas",
        alt2: "Ante tareas nuevas pido asistencia para resolverlas",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20827,
        id_instrumento: 208,
        id_correlativo: 27,
        texto: "",
        alt1: "Suelo corroborar la información que se me entrega",
        alt2: "Si entendí lo que se me pidió, no vuelvo a corroborar",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20828,
        id_instrumento: 208,
        id_correlativo: 28,
        texto: "",
        alt1: "Soy capaz de hacer lo que se me pide   ",
        alt2: "Sé que soy capaz de hacer más de lo que se me pide",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20829,
        id_instrumento: 208,
        id_correlativo: 29,
        texto: "",
        alt1: "Trabajo en forma segura de lo que sé ",
        alt2: "Trabajo con interés por aprender ",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20830,
        id_instrumento: 208,
        id_correlativo: 30,
        texto: "",
        alt1: "Frente a un problema procedo con método ",
        alt2: "Frente a un problema procedo con iniciativa",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20831,
        id_instrumento: 208,
        id_correlativo: 31,
        texto: "",
        alt1: "Ante un problema, me pregunto si podré resolverlo",
        alt2: "Ante un problema tengo la seguridad que podré resolverlo",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20832,
        id_instrumento: 208,
        id_correlativo: 32,
        texto: "",
        alt1: "Ante un jefe/a me presento con seguridad",
        alt2: "Ante un jefe/a me presento con respeto",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20833,
        id_instrumento: 208,
        id_correlativo: 33,
        texto: "",
        alt1: "Entre mis compañeros/as soy reconocido/a por mi seguridad al abordar las tareas",
        alt2: "Entre mis compañeros/as soy reconocido/a por mi disciplina al abordar las tareas",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20834,
        id_instrumento: 208,
        id_correlativo: 34,
        texto: "",
        alt1: "Aunque estoy capacitado/a siempre estoy alerta a cualquier riesgo que pudiera originar",
        alt2: "Se que estoy capacitado/a para hacer, sin riesgos, mi trabajo",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20835,
        id_instrumento: 208,
        id_correlativo: 35,
        texto: "",
        alt1: "Motivo a mis compañeros/as para que desarrollen su confianza al enfrentar las tareas ",
        alt2: "Motivo a mis compañeros/as para que actúen con cautela al enfrentar las tareas",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20836,
        id_instrumento: 208,
        id_correlativo: 36,
        texto: "",
        alt1: "Tengo confianza en los demás y en sus buenas intenciones, incluso, cuando hay riesgos involucrados",
        alt2: "Tengo confianza en los demás y en sus buenas intenciones, pero, igual verifico por los posibles riesgos involucrados",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20837,
        id_instrumento: 208,
        id_correlativo: 37,
        texto: "",
        alt1: "A veces mis compañeros/as me dicen que soy un poco ingenuo/a al confiar ",
        alt2: "A veces mis compañeros/as me dicen que soy un poco desconfiado al dudar ",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20838,
        id_instrumento: 208,
        id_correlativo: 38,
        texto: "",
        alt1: "Mi predisposición es a confiar en los otros",
        alt2: "Mi predisposición es observar quién es digno de mi confianza",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20839,
        id_instrumento: 208,
        id_correlativo: 39,
        texto: "",
        alt1: "Soy precavido en determinar en quién se confía y en qué grado",
        alt2: "Confío en la gente sin discriminar a nadie",
        alt3: "",
        alt4: "",
        alt5: "",
      },
      {
        id_pregunta: 20840,
        id_instrumento: 208,
        id_correlativo: 40,
        texto: "",
        alt1: "Asumo que no todos son confiables y soy prudente cuando se trata con desconocidos ",
        alt2: "Asumo que las personas son confiables hasta que haya evidencias que me indiquen lo contrario",
        alt3: "",
        alt4: "",
        alt5: "",
      },
    ],
  },
];
